import React from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookOpen, faBullseye, faDownload } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";
import doc from './../../assets/Department Information and Details.pdf';

const Brochure = () => {
  return (
    <>
      <div style={{
        backgroundImage: `url(${footerBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '30px 0',
        color: 'white',
        margin: '2%',
        borderRadius: '10px'
      }}>
        <Container>
          <h3 className="fw-bold mb-0 text-center">
            <FontAwesomeIcon icon={faBookOpen} className="me-2" />
            Brochure
          </h3>
        </Container>
      </div>

      <Container className="py-5">
        <Row>
          {/* Introduction Card */}
          <Col lg={6} className="mb-4">
            <Card className="h-100 border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
              <div style={{
                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                padding: '25px',
                color: 'white'
              }}>
                <h4 className="fw-bold mb-0">
                  <FontAwesomeIcon icon={faBookOpen} className="me-2" />
                  Introduction
                </h4>
              </div>
              <CardBody className="p-4">
                <p style={{ color: '#495057', lineHeight: '1.8', textAlign: 'justify' }}>
                  The Government of Haryana established the Sainik and Ardh Sainik Welfare Department at the state level and the District Sainik and Ardh Sainik Welfare Offices at the district level, as per Notification No. 6/5/2016-1Cabinet dated 27th December 2016. The primary objective of these offices is to lookafter the welfare of serving and retired personnel of Defence and Para Military Forces, Ex-Servicemen (ESM), War Widows, Widows of ESM/CAPF personnel and their dependents. The department aims to provide comprehensive support and assistance to ensure the well-being of these individuals in various aspects of their lives.
                </p>
              </CardBody>
            </Card>
          </Col>

          {/* Aim Card */}
          <Col lg={6} className="mb-4">
            <Card className="h-100 border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(22,160,133,0.15)' }}>
              <div style={{
                background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
                padding: '25px',
                color: 'white'
              }}>
                <h4 className="fw-bold mb-0">
                  <FontAwesomeIcon icon={faBullseye} className="me-2" />
                  Aim
                </h4>
              </div>
              <CardBody className="p-4">
                <p style={{ color: '#495057', lineHeight: '1.8', textAlign: 'justify' }}>
                  Government of Haryana is committed to ensuring the
                  welfare of serving and retired soldiers from the Armed Forces
                  and Central Armed Police Forces (CAPF), along with their
                  families, widows and orphans.
                </p>
                <p style={{ color: '#495057', lineHeight: '1.8', textAlign: 'justify' }}>
                  Commitment includes the active implementation of
                  various welfare policies and schemes designed by both the
                  Government of Haryana and the Government of India, as well
                  as the Kendriya Sainik Board.
                </p>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Download Button */}
        <Row className="mt-3">
          <Col lg={12} className="text-center">
            <a
              className="btn"
              href={doc}
              target='_blank'
              rel="noopener noreferrer"
              download="Brochure.pdf"
              style={{
                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                color: 'white',
                borderRadius: '12px',
                padding: '14px 30px',
                textDecoration: 'none',
                fontWeight: '600',
                boxShadow: '0 4px 15px rgba(30,60,114,0.3)',
                display: 'inline-flex',
                alignItems: 'center'
              }}
            >
              <FontAwesomeIcon icon={faDownload} className="me-2" />
              Download Brochure
            </a>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Brochure